<template>
  <div class="flex flex-col">
    <div class="flex">
      <app-logo v-hubble="'app-logo'" class="h-12 shrink-0 w-12" />

      <div class="flex flex-col h-full justify-center ml-2 space-y-2 w-full">
        <p v-hubble="'org-name'" class="font-bold leading-4 text-white">{{ $auth.user.orgName }}</p>
        <div class="flex space-x-2">
          <org-type-badge :type="$auth.user.org.type" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLogo from '~/components/common/AppLogo';
import OrgTypeBadge from '~/components/orgs/OrgTypeBadge';

export default {
  name: 'AppSidebarSubscriptionCard',

  hubble: 'app-sidebar-subscription-card',

  components: { AppLogo, OrgTypeBadge },
};
</script>
